function uploadElement(id) {
  return document.getElementById(`direct-upload-${id}`)
}

addEventListener("direct-upload:initialize", ({ target, detail: { id, file } }) => {
  const upload = document.createElement("div")
  upload.id = `direct-upload-${id}`
  upload.className = "direct-upload direct-upload--pending"

  const progress = document.createElement("div")
  progress.id = `direct-upload-progress-${id}`
  progress.className = "direct-upload__progress"
  progress.style.width = "0%"

  const filename = document.createElement("span")
  filename.className = "direct-upload__filename"
  filename.textContent = file.name

  upload.append(progress, filename)
  target.insertAdjacentElement("beforebegin", upload)
})

addEventListener("direct-upload:start", ({ detail: { id } }) => {
  const upload = uploadElement(id)
  if (upload) upload.classList.remove("direct-upload--pending")
})

addEventListener("direct-upload:progress", ({ detail: { id, progress } }) => {
  const progressElement = document.getElementById(`direct-upload-progress-${id}`)
  if (progressElement) progressElement.style.width = `${progress}%`
})

addEventListener("direct-upload:error", event => {
  event.preventDefault()

  const upload = uploadElement(event.detail.id)
  if (!upload) return

  upload.classList.add("direct-upload--error")
  upload.setAttribute("title", event.detail.error)
})

addEventListener("direct-upload:end", ({ detail: { id } }) => {
  const upload = uploadElement(id)
  if (upload) upload.classList.add("direct-upload--complete")
})
